module.exports = __webpack_public_path__ + "assets/pdf/E01-cn-investigating-heatwaves.2401983c.pdf";